import { Subscription } from 'rxjs';
import { Response, Message } from '@thrivesoft/gocore-web';

export abstract class ObserverRepository {
    abstract observeProperty(propertyId: string, callback?: (r: Response) => void): Subscription;
    abstract updateProperty<T extends Message>(propertyId: string, data: T): void;
}